import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="bg-stage-deep water-glow tech-grid py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-189" data-mp="30gxtpw8ufdm8">
      <div className="mx-auto max-w-4xl px-4" data-id="element-190" data-mp="2vpzbgr4ao5gc">
        <div className="text-center" data-id="element-191" data-mp="2vowj0erbpuyb">
          <h2 id="problem-title" className="text-balance text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-192" data-mp="39hw2ssy52bbo">
            Does this sound familiar?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-silver" data-id="element-193" data-mp="35idgptukzu79">
            Sunday at 11 p.m. Tomorrow you have hydrology class. And you're still searching for the best way to explain
            groundwater contamination, flood risk, and water resource management without losing your students'
            attention.
          </p>
          <p className="mx-auto mt-4 max-w-3xl leading-relaxed text-silverDark" data-id="element-194" data-mp="1k3r94an0vlsq">
            It's not your fault. You've spent years struggling with disorganized materials, dense theory from outdated
            textbooks, and resources designed for contexts you have to completely rewrite.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="panel-dark mt-10 rounded-xl border border-silverEdge p-6 sm:p-8" data-id="element-195" data-mp="sd076b7gukfm">
          <p className="mb-5 inline-flex items-center gap-2 font-display text-xl font-bold text-white" data-id="element-196" data-mp="1714rfjm6340i">
            <AlertTriangleIcon className="h-5 w-5 text-danger" aria-hidden="true" data-id="element-197" data-mp="1c2kbp9git6hu" />
            The real cost of not having the right materials
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-198" data-mp="3dtnred59pb99">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-silver" data-id="element-199" data-mp="3huhfb6ipmq25">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-danger" aria-hidden="true" data-id="element-200" data-mp="p00n7wux3z2a" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-201" data-mp="y0ytymwqqkok">
          <p className="text-lg font-bold text-silverBright" data-id="element-202" data-mp="y1qf13spp00l">
            Stop giving away your personal time. Your dedication is already there. What you need now is the right tool.
          </p>
          <p className="mt-3 font-display text-2xl font-extrabold text-white sm:text-3xl" data-id="element-203" data-mp="17xtqx1dd8d0q">Plan your entire year today.</p>
        </div>
      </div>
    </section>;
}